import { useQuery } from '@tanstack/react-query';
import {
  DEFAULT_ORGANIZATION_DISPLAY_SETTINGS,
  getOrganizationDisplaySettings,
  type OrganizationDisplaySettings,
} from '../utils/api';

export const ORGANIZATION_DISPLAY_SETTINGS_QUERY_KEY = ['organization-display-settings'] as const;

export function useOrganizationDisplaySettings() {
  return useQuery<OrganizationDisplaySettings>({
    queryKey: ORGANIZATION_DISPLAY_SETTINGS_QUERY_KEY,
    queryFn: getOrganizationDisplaySettings,
    staleTime: 5 * 60 * 1000,
    placeholderData: (previousData) => previousData ?? DEFAULT_ORGANIZATION_DISPLAY_SETTINGS,
  });
}
